module.exports = __webpack_public_path__ + "media/assets/svg/logos/nosco_logo-ecf3c6ffcf3e046d6960bfc046f50372.svg";